/**
 * tdesign v1.11.4
 * (c) 2025 tdesign
 * @license MIT
 */

import './useConfig.mjs';
import { useConfig } from '../config-provider/hooks/useConfig.mjs';
import 'vue';
import 'lodash-es';
import '../config-provider/utils/context.mjs';
import '../_chunks/dep-99da72b8.mjs';
import '../_chunks/dep-6da93342.mjs';
import '../_chunks/dep-b0ea6825.mjs';
import '../_chunks/dep-2705c570.mjs';
import '../_chunks/dep-bc824998.mjs';
import '../config-provider/type.mjs';

function useGlobalIcon(tdIcon) {
  var _useConfig = useConfig("icon"),
    globalConfig = _useConfig.globalConfig;
  var resultIcon = {};
  Object.keys(tdIcon).forEach(function (key) {
    var _globalConfig$value;
    resultIcon[key] = ((_globalConfig$value = globalConfig.value) === null || _globalConfig$value === void 0 ? void 0 : _globalConfig$value[key]) || tdIcon[key];
  });
  return resultIcon;
}

export { useGlobalIcon as default, useGlobalIcon };
//# sourceMappingURL=useGlobalIcon.mjs.map
